import { render } from "./TherapyBundleManagement.vue?vue&type=template&id=aedac35e&scoped=true"
import script from "./TherapyBundleManagement.vue?vue&type=script&lang=js"
export * from "./TherapyBundleManagement.vue?vue&type=script&lang=js"

import "./TherapyBundleManagement.vue?vue&type=style&index=0&id=aedac35e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aedac35e"]])

export default __exports__